<template>
<v-main style="padding-bottom: 10vh;">
    <v-row justify="center">
        <v-col cols="12" lg="10" xl="10">
            <v-img :src="require('@/assets/FLYER.jpg')" cover/>
        </v-col>
    </v-row>
</v-main>
</template>